import React, { useMemo, useState, useEffect } from 'react';
import {Button, Form} from 'antd';
import DateFilterItem from 'pages/delivery/components/DateFilterItem';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { isBeforeTime } from '../../../../utils/timezoneUtils';
import { WarehouseType } from '../../../../graphql/types/WarehouseType';

export interface PickupTaskPlanningFilterProps {
    loadings: boolean[];
    enterLoading: (index: number) => void;
    onCreateRoute: () => void;
    onCreatePickupTask: () => void;
    pickupDate: dayjs.Dayjs | null;
    onPickupDateChange: (date: dayjs.Dayjs | null) => void;
    isTaskRunning?: boolean;
    isButtonDisabled?: boolean;
    warehouse?: WarehouseType | null;
    disableCreateTask?: boolean;
    disableCreateRoute?: boolean;
}

const PickupTaskPlanningFilter: React.FC<PickupTaskPlanningFilterProps> = ({
                                                            loadings,
                                                            enterLoading,
                                                            onCreateRoute,
                                                            onCreatePickupTask,
                                                            pickupDate,
                                                            onPickupDateChange,
                                                            isTaskRunning,
                                                            isButtonDisabled,
                                                            warehouse,
                                                            disableCreateTask = false,
                                                            disableCreateRoute = false,
                                                            //    filter,
                                                            //    onFilterChange,
                                                            //    onFilter,
                                                            //    onReset
                                                           }) => {
    const {t} = useTranslation();

    // 添加一个状态来触发重新渲染
    const [currentTime, setCurrentTime] = useState(() => dayjs());

    // 每分钟更新一次当前时间，确保按钮状态能够及时更新
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(dayjs());
        }, 60000); // 每分钟更新一次

        return () => clearInterval(timer);
    }, []);

    // 检查按钮是否应该在9点前被禁用
    const shouldDisableBefore9AM = useMemo(() => {
        // 如果没有warehouse信息，默认不禁用
        if (!warehouse) {
            return false;
        }

        // 优先使用timezoneLocation，如果没有再使用timezone
        const timezone = warehouse.timezoneLocation || warehouse.timezone;
        if (!timezone) {
            return false;
        }

        // 获取当前筛选的日期
        const targetDate = pickupDate?.format('YYYY-MM-DD') || dayjs().format('YYYY-MM-DD');
        
        // 检查当前时间是否在目标日期的9点前
        return isBeforeTime(timezone, targetDate, 9);
    }, [warehouse, pickupDate, currentTime]);


    return (
        <Form>
            <div className="flex justify-between items-center mb-3 pl-0">
                {/* 左侧按钮组 */}
                <div className="flex items-center gap-2">
                    <Button 
                        type="primary" 
                        className="w-auto min-w-24"
                        onClick={onCreateRoute}
                        hidden={disableCreateRoute}
                    >
                        <span className="font-bold">{t('pickup.pickupTask.buttons.createRoute')}</span>
                    </Button>
                </div>

                {/* 右侧内容组 */}
                <div className="flex items-center gap-2 flex-1 justify-end">
                    <div className="flex-1 max-w-[33.333%] min-w-0">
                        <DateFilterItem
                            label={t('pickup.pickupTask.filters.pickupDate')}
                            value={pickupDate || dayjs()}
                            minDate={dayjs()}
                            maxDate={dayjs().add(1, 'day')}
                            onChange={(date) => onPickupDateChange(date || dayjs())}
                            className="!flex-row !items-center"
                            spanClassName="!font-medium !mb-0 !mr-3 whitespace-nowrap"
                        />
                    </div>
                    <Button
                        type="primary"
                        className="w-auto min-w-24 flex-shrink-0"
                        loading={isTaskRunning}
                        disabled={isTaskRunning || (isButtonDisabled === true)  }
                        hidden={disableCreateTask}
                        onClick={onCreatePickupTask}

                        >
                        <span className="font-bold">{isTaskRunning ? t('pickup.pickupTask.buttons.taskRunning') : t('pickup.pickupTask.buttons.createPickupTask')}</span>
                    </Button>

                </div>
            </div>
        </Form>
    );
};

export default PickupTaskPlanningFilter; 